import React from 'react';
import { useTranslation } from 'react-i18next';

import { Colors, Typography, createClasses } from '@kp/react-ui';

const classes = createClasses({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 16px',
  },
  dots: {
    display: 'flex',
    gap: '4px',
  },
  dot: {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    backgroundColor: Colors.Selected.backgroundStrong,
    animationName: 'chatBounce',
    animationDuration: '1.4s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-in-out',
  },
  dot1: {
    animationDelay: '0s',
  },
  dot2: {
    animationDelay: '0.2s',
  },
  dot3: {
    animationDelay: '0.4s',
  },
  text: {
    color: Colors.Neutral.textWeak,
  },
  '@global': {
    '@keyframes chatBounce': {
      '0%, 80%, 100%': {
        transform: 'scale(0.6)',
        opacity: 0.4,
      },
      '40%': {
        transform: 'scale(1)',
        opacity: 1,
      },
    },
  },
});

interface LoadingIndicatorProps {
  text: string;
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ text }) => {
  const { t } = useTranslation('chat');

  return (
    <div className={classes.root}>
      <div className={classes.dots} data-testid="loading-dots">
        <div className={`${classes.dot} ${classes.dot1}`} />
        <div className={`${classes.dot} ${classes.dot2}`} />
        <div className={`${classes.dot} ${classes.dot3}`} />
      </div>
      <Typography variant="bodySmall" className={classes.text}>
        {t(text)}
      </Typography>
    </div>
  );
};
